import React from "react";
import PropTypes from "prop-types";
import { CtaButton } from "../../Elements";

import {
	FullWidthCtaWrapper,
	FullWidthCta,
	Header,
	CTAWrapper,
	Description,
	OneLineFullWidthCta,
	OneLineHeader,
	OneLineCTAWrapper,
} from "./styles";

const FullWidthCTA = (props) => {
	const {
		header,
		description,
		fontColor,
		cta,
		context,
		oneLineCta,
		hoverColor,
	} = props;
	return (
		<FullWidthCtaWrapper>
			{!oneLineCta ? (
				<FullWidthCta>
					{header && <Header fontColor={fontColor}>{header}</Header>}
					{description && (
						<Description
							fontColor={fontColor}
							dangerouslySetInnerHTML={{
								__html: description,
							}}
						/>
					)}
					{cta ? (
						<CTAWrapper>
							<CtaButton
								cta={cta}
								className="ctaButton"
								pathName={context.fullSlug}
							/>
						</CTAWrapper>
					) : null}
				</FullWidthCta>
			) : (
				<OneLineFullWidthCta>
					{header && (
						<OneLineHeader fontColor={fontColor}>{header}</OneLineHeader>
					)}
					{cta ? (
						<OneLineCTAWrapper hoverColor={hoverColor}>
							<CtaButton
								cta={cta}
								className="ctaButton"
								pathName={context.fullSlug}
							/>
						</OneLineCTAWrapper>
					) : null}
				</OneLineFullWidthCta>
			)}
		</FullWidthCtaWrapper>
	);
};

FullWidthCTA.propTypes = {
	header: PropTypes.string.isRequired,
	description: PropTypes.string,
	fontColor: PropTypes.string,
	cta: PropTypes.shape({
		link: PropTypes.shape({
			type: PropTypes.oneOf(["hash", "external", "internal"]),
			value: PropTypes.string,
		}),
		color: PropTypes.string,
		type: PropTypes.oneOf(["solid", "outline"]),
		text: PropTypes.string,
	}),
	context: PropTypes.shape({
		fullSlug: PropTypes.string.isRequired,
	}).isRequired,
	oneLineCta: PropTypes.bool,
	hoverColor: PropTypes.shape({
		outline: PropTypes.string,
		background: PropTypes.string,
		text: PropTypes.string,
	}),
};

FullWidthCTA.defaultProps = {
	header: "",
	description: "",
	fontColor: "",
	cta: null,
	context: { fullSlug: "" },
	oneLineCta: false,
	hoverColor: {
		outline: null,
		background: null,
		text: null,
	},
};

export default FullWidthCTA;
